import type { InputHTMLAttributes } from 'react';
import { type FieldShellProps, FormField } from './FormField';

type NativeProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'id' | 'className' | 'required'>;

interface TextFieldProps extends FieldShellProps, NativeProps {
  /** Rendered inside the control's leading edge, e.g. a currency symbol. */
  prefix?: string | undefined;
  /** Rendered inside the control's trailing edge, e.g. a unit. */
  suffix?: string | undefined;
}

export function TextField({
  label,
  hideLabel,
  error,
  helpText,
  required,
  className,
  prefix,
  suffix,
  ...input
}: TextFieldProps) {
  return (
    <FormField
      label={label}
      hideLabel={hideLabel}
      error={error}
      helpText={helpText}
      required={required}
      className={className}
    >
      {({ id, describedBy, invalid }) => (
        <div className="c-input">
          {prefix && <span className="c-input__prefix">{prefix}</span>}
          <input
            {...input}
            id={id}
            required={required}
            aria-describedby={describedBy}
            aria-invalid={invalid || undefined}
            className="c-input__control"
          />
          {suffix && <span className="c-input__suffix">{suffix}</span>}
        </div>
      )}
    </FormField>
  );
}
